export const DraggableTypes = {
    EVENT: 'EVENT',
    MODAL: 'MODAL',
}